import * as api from '../api/version';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'ASSESSMENT/VERSION';

export const VERSIONS_FETCH_START = `${namespace}/VERSIONS_FETCH_START`;
export const VERSIONS_FETCH_SUCCESS = `${namespace}/VERSIONS_FETCH_SUCCESS`;
export const VERSIONS_FETCH_ERROR = `${namespace}/VERSIONS_FETCH_ERROR`;

export const fetchVersions = makeApiActionCreatorV3(
  api.fetchVersions,
  VERSIONS_FETCH_START,
  VERSIONS_FETCH_SUCCESS,
  VERSIONS_FETCH_ERROR,
);

export const CREATE_VERSION_START = `${namespace}/CREATE_VERSION_START`;
export const CREATE_VERSION_SUCCESS = `${namespace}/CREATE_VERSION_SUCCESS`;
export const CREATE_VERSION_ERROR = `${namespace}/CREATE_VERSION_ERROR`;

export const createVersion = makeApiActionCreatorV3(
  api.createVersion,
  CREATE_VERSION_START,
  CREATE_VERSION_SUCCESS,
  CREATE_VERSION_ERROR,
);

export const VERSION_DELETE_START = `${namespace}/VERSION_DELETE_START`;
export const VERSION_DELETE_SUCCESS = `${namespace}/VERSION_DELETE_SUCCESS`;
export const VERSION_DELETE_ERROR = `${namespace}/VERSION_DELETE_ERROR`;

export const deleteVersion = makeApiActionCreatorV3(
  api.deleteVersion,
  VERSION_DELETE_START,
  VERSION_DELETE_SUCCESS,
  VERSION_DELETE_ERROR,
);

export const UPDATE_VERSION_START = `${namespace}/UPDATE_VERSION_START`;
export const UPDATE_VERSION_SUCCESS = `${namespace}/UPDATE_VERSION_SUCCESS`;
export const UPDATE_VERSION_ERROR = `${namespace}/UPDATE_VERSION_ERROR`;

export const updateVersion = makeApiActionCreatorV3(
  api.updateVersion,
  UPDATE_VERSION_START,
  UPDATE_VERSION_SUCCESS,
  UPDATE_VERSION_ERROR,
);

export const ACTIVATE_VERSION_START = `${namespace}/ACTIVATE_VERSION_START`;
export const ACTIVATE_VERSION_SUCCESS = `${namespace}/ACTIVATE_VERSION_SUCCESS`;
export const ACTIVATE_VERSION_ERROR = `${namespace}/ACTIVATE_VERSION_ERROR`;

export const activateVersion = makeApiActionCreatorV3(
  api.activateVersion,
  ACTIVATE_VERSION_START,
  ACTIVATE_VERSION_SUCCESS,
  ACTIVATE_VERSION_ERROR,
);

export const VERSION_EXEMPTIONS_FETCH_START = `${namespace}/VERSION_EXEMPTIONS_FETCH_START`;
export const VERSION_EXEMPTIONS_FETCH_SUCCESS = `${namespace}/VERSION_EXEMPTIONS_FETCH_SUCCESS`;
export const VERSION_EXEMPTIONS_FETCH_ERROR = `${namespace}/VERSION_EXEMPTIONS_FETCH_ERROR`;

export const fetchVersionExemptions = makeApiActionCreatorV3(
  api.fetchVersionExemptions,
  VERSION_EXEMPTIONS_FETCH_START,
  VERSION_EXEMPTIONS_FETCH_SUCCESS,
  VERSION_EXEMPTIONS_FETCH_ERROR,
);

export const DELETE_VERSION_EXEMPTION_START = `${namespace}/DELETE_VERSION_EXEMPTION_START`;
export const DELETE_VERSION_EXEMPTION_SUCCESS = `${namespace}/DELETE_VERSION_EXEMPTION_SUCCESS`;
export const DELETE_VERSION_EXEMPTION_ERROR = `${namespace}/DELETE_VERSION_EXEMPTION_ERROR`;

export const deleteVersionExemption = makeApiActionCreatorV3(
  api.deleteVersionExemption,
  DELETE_VERSION_EXEMPTION_START,
  DELETE_VERSION_EXEMPTION_SUCCESS,
  DELETE_VERSION_EXEMPTION_ERROR,
);

export const CREATE_VERSION_EXEMPTION_START = `${namespace}/CREATE_VERSION_EXEMPTION_START`;
export const CREATE_VERSION_EXEMPTION_SUCCESS = `${namespace}/CREATE_VERSION_EXEMPTION_SUCCESS`;
export const CREATE_VERSION_EXEMPTION_ERROR = `${namespace}/CREATE_VERSION_EXEMPTION_ERROR`;

export const createVersionExemption = makeApiActionCreatorV3(
  api.createVersionExemption,
  CREATE_VERSION_EXEMPTION_START,
  CREATE_VERSION_EXEMPTION_SUCCESS,
  CREATE_VERSION_EXEMPTION_ERROR,
);

export const UPDATE_VERSION_EXEMPTION_START = `${namespace}/UPDATE_VERSION_EXEMPTION_START`;
export const UPDATE_VERSION_EXEMPTION_SUCCESS = `${namespace}/UPDATE_VERSION_EXEMPTION_SUCCESS`;
export const UPDATE_VERSION_EXEMPTION_ERROR = `${namespace}/UPDATE_VERSION_EXEMPTION_ERROR`;

export const updateVersionExemption = makeApiActionCreatorV3(
  api.updateVersionExemption,
  UPDATE_VERSION_EXEMPTION_START,
  UPDATE_VERSION_EXEMPTION_SUCCESS,
  UPDATE_VERSION_EXEMPTION_ERROR,
);

export const VERSION_TAX_RATES_FETCH_START = `${namespace}/VERSION_TAX_RATES_FETCH_START`;
export const VERSION_TAX_RATES_FETCH_SUCCESS = `${namespace}/VERSION_TAX_RATES_FETCH_SUCCESS`;
export const VERSION_TAX_RATES_FETCH_ERROR = `${namespace}/VERSION_TAX_RATES_FETCH_ERROR`;

export const fetchVersionTaxRates = makeApiActionCreatorV3(
  api.fetchVersionTaxRates,
  VERSION_TAX_RATES_FETCH_START,
  VERSION_TAX_RATES_FETCH_SUCCESS,
  VERSION_TAX_RATES_FETCH_ERROR,
);

export const UPDATE_VERSION_TAX_RATE_START = `${namespace}/UPDATE_VERSION_TAX_RATE_START`;
export const UPDATE_VERSION_TAX_RATE_SUCCESS = `${namespace}/UPDATE_VERSION_TAX_RATE_SUCCESS`;
export const UPDATE_VERSION_TAX_RATE_ERROR = `${namespace}/UPDATE_VERSION_TAX_RATE_ERROR`;

export const updateVersionTaxRate = makeApiActionCreatorV3(
  api.updateVersionTaxRate,
  UPDATE_VERSION_TAX_RATE_START,
  UPDATE_VERSION_TAX_RATE_SUCCESS,
  UPDATE_VERSION_TAX_RATE_ERROR,
);
